<template lang="pug">
Common.not-found(title='Page not found' :errors='errors')
  h1(slot='header') The requested page could not be found

  .fl-center(slot='main')
    p Sorry, '{{ path }}' doesn't seem to exist...

    template(v-if='isLoggedIn')
      p You can return to the dashboard
        router-link(:to='$site.Routes.Home')  here
    template(v-else)
      p You can login 
        router-link(:to='$site.Routes.Login.Root')  here
</template>

<script>
import "./scss";
import { report } from "@/utils";
import { Common } from "AccountPages/components";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { GemmaError } from "@gemma/errors";

export default {
  name: "NotFound",
  components: {
    Common,
  },
  data() {
    return {
      errors: [],
      isLoggedIn: false,
      title: "Page Not Found",
    };
  },
  computed: {
    path() {
      return this.$route.query.url || decodeURI(this.$route.fullPath);
    },
  },
  async created() {
    this.$store.commit("header/title", {
      context: this,
      faIcon: this.$icons.help,
      text: this.title,
    });

    const currentSession = await this.$app.api.getCurrentSession();
    this.isLoggedIn = currentSession.account.isLoggedIn;
  },
  updated() {
    this.$nextTick(async function() {
      const error = new GemmaError(`Page "${this.path}" not found.`, { data: this.path });
      await report.error(error, false);
    });
  },
};
</script>
